import { render, staticRenderFns } from "./index.vue?vue&type=template&id=394fac44&scoped=true&lang=html&"
import script from "./mergeSpread.js?vue&type=script&lang=js&"
export * from "./mergeSpread.js?vue&type=script&lang=js&"
import style0 from "./mergeSpread.styl?vue&type=style&index=0&lang=stylus&"
import style1 from "./resetVant.styl?vue&type=style&index=1&id=394fac44&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394fac44",
  null
  
)

export default component.exports